import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class ProgramarModal implements OnInit {
  public form: FormGroup;
  llimite: string;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ProgramarModal>,

    @Inject(MAT_DIALOG_DATA)
    public data: { needDate: boolean; tiposServicios: any[] }
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.llimite = new Date().toISOString().slice(0, 10);
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      FechaProgramado: [new Date(), Validators.required],
      Razon: [""],
      ReparacionOServicio: ["", Validators.required],
      Servicio: [""],
    });

    // Add conditional validator for Servicio
    this.form.get("ReparacionOServicio")!.valueChanges.subscribe((value) => {
      const servicioControl = this.form.get("Servicio");
      if (value === 2) {
        servicioControl!.setValidators(Validators.required);
      } else {
        servicioControl!.clearValidators();
      }
      servicioControl!.updateValueAndValidity();
    });
  }

  save() {
    const data = this.form.value;
    this.dialogRef.close({
      ...data,
      Tipo: 1,
    });
  }
}
